import { render, staticRenderFns } from "./ReceiveNum.vue?vue&type=template&id=5f3d32e3&scoped=true"
import script from "./ReceiveNum.vue?vue&type=script&lang=js"
export * from "./ReceiveNum.vue?vue&type=script&lang=js"
import style0 from "./ReceiveNum.vue?vue&type=style&index=0&id=5f3d32e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d32e3",
  null
  
)

export default component.exports